export default __webpack_public_path__ + "static/media/highlighted-marker.2ce15e64.png";